import LoggedInTopbar from "layout/topbar/logged-in";
import { ChatPage } from "./chat";
import vdcom from "../../lib/vd";
import page from "page";

export const chatPageController = async (context, next) => {
  const chatId = context.params.chatId;

  let initialChat;

  if (chatId) {
    try {
      const chat = await vdcom.ai().getChat(chatId);

      if (!chat) {
        throw new Error("Chat not found");
      }

      initialChat = chat;
    } catch (err) {
      console.log(err);
      return page.redirect(`/chat`);
    }
  }

  context.primary = <ChatPage initialChat={initialChat} />;
  next();
};

export const navigation = (context, next) => {
  context.topbar = <LoggedInTopbar path={context.path} />;
  next();
};
